<template>
<div>
    <transition :enter-active-class="animations.standard.enter" :leave-active-class="animations.standard.leave" :name="animations.standard.name">
      <div class="row" v-if="ready">
        <div class="col call-chat-body">
          <div class="card">
            <div class="card-body p-0">
              <div class="row chat-box">
                <!-- Chat right side start-->
                <div class="col pr-0 chat-right-aside">
                  <!-- chat start-->
                  <div class="chat" v-if="currentChat.active && customerAvatarsLoaded">
                    <!-- chat-header start-->
                    <div class="chat-header clearfix">
                      <div v-for="(recipient, idx) in avatars" :key="idx" class="chat-avatars">
                        <img class="rounded-circle" :src="typeof recipient.avatar == 'object' ? recipient.avatar.url : recipient.avatar" />
                        <div class="about">
                          <div class="name">
                            {{ recipient.first_name }} <br /> {{ recipient.last_name }}
                            <!--<span class="font-primary f-12">Typing...</span>-->
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- chat-header end-->
                    <div class="chat-history chat-msg-box custom-scrollbar" ref="current_chat_container" @scroll="loadMoreScroll">
                      <loaderRelative class="load-more-loader" v-if="loadingMore"/>
                      <ul v-if="currentMessagesLoaded">
                        <li v-for="(message, idx) in currentMessages" :key="idx" :class="{ clearfix: message.sender != user.id }">
                          <div
                            class="message"
                            :class="{
                              'my-message': message.sender == user.id,
                              'other-message': message.sender != user.id,
                              'pull-right': message.sender != user.id,
                            }"
                          >
                            <img
                              class="rounded-circle float-left chat-user-img img-30"
                              v-if="message.sender == user.id"
                              :src="getAvatar(user.id)"
                              alt
                            />
                            <img
                              class="rounded-circle float-right chat-user-img img-30"
                              v-if="message.sender != user.id"
                              :src="getAvatar(message.sender)"
                              alt
                            />
                            <div class="message-data">
                              <span class="message-data-time">{{ transformDate(message.created_on) }}</span>
                            </div>
                            {{ message.message }}
                          </div>
                        </li>
                        <div>
                          <div class="image-not-found">
                            <div class="d-block start-conversion">
                              <img class="img-fluid" />
                            </div>
                          </div>
                        </div>
                      </ul>
                    </div>
                    <!-- end chat-history-->
                    <div class="chat-message clearfix">
                      <div class="row">
                        <div class="col-xl-12 d-flex">
                          <div class="input-group text-box text-with-loader">
                            <textarea
                              class="form-control input-txt-bx"
                              id="message-to-send"
                              type="text"
                              name="message-to-send"
                              placeholder="Nachricht schreiben..."
                              v-model="currentChat.newMessage"
                              @focus="scrollToBottom"
                              v-focus                             
                              :disabled="currentChat.updating"
                              autocomplete="off"
                            />
                            <div class="loader-container">
                              <Loader v-if="currentChat.updating" size="30" />
                            </div>
                            <div class="input-group-append">
                              <button ref="sendButton" class="btn btn-primary" type="button" @click="sendMessage()">Senden</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end chat-message-->
                    <!-- Chat right side-->
                  </div>
                </div>                
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import Loader from "@/components/loader.vue";
import LoaderRelative from "@/components/LoaderRelative.vue";

export default {
  name: "ChatCustomer",
  data() {
    return {
      ready: false,
      themenOfUser: [],
      allUsers: [],
      currentChat: {
        chatMe: false,
        chat: false,        
        updating: false,
        active: false,
        newMessage: "",
      },
      chatRefresh: null,
      currentMessagesLoaded: false,
      currentMessages: [],
      loadedMessagesByChat: [],
      lockRefresh: false,
      loadingMore: false,
      tabindex: 0,
      offSetBase: 5,
      addressExclusionList: [1, 81, 113, 122, 227, 226],
      debugMsg: [],
      fallBackAvatarUrl: false,       
      msgLoadedran: 0     
    };
  },
  components: {
    Loader,
    LoaderRelative,
  },
  watch: {
    activeChats: function() {         
      this.refreshcurrentChat();
      this.selectCurrentChat(this.dialogues[0].id);
      //this.checkDialogues();
    },
  },  
  methods: {
    loadMoreScroll(evt) {      
      if(evt.target.scrollTop == 0) {
        this.loadMoreCurrentChatMessages();
      }
    },
    checkIfSeen(chat) {
      if (!chat.seenby) return true;
      const result = chat.seenby.find((c) => c == this.user.id);
      return result;
    },
    isCustomer(usr) {
      const user = this.allUsers.find((u) => u.id == usr);
      return user.role == 'f0995ff3-21fd-41a8-91fa-551469b0c5a6';
    },
    getName(id, shorten = false) {
      if (!this.allUsers.length) return;
      const user = this.allUsers.find((u) => u.id == id);
      const str = `${user.first_name} ${user.last_name}`;
      const formattedName = shorten ? str.substring(0, 20) : str;
      return formattedName;
    },
    /** 
    * @description returns the avatar Url for a user Id from the store
    * @param {id} the user id to retrieve the avatar for
    */
    getAvatar(id) {

      if(!this.avatars.length) return;
      const avatar = this.avatars.find(a => a.user == id);   
      if(!avatar) return;   
      return avatar.avatar;
    },
    getLastMessage(chatId, userId) {
      const theChat = this.activeChats.find((c) => c.chat_id == chatId);
      if (undefined == theChat) return;
      const lastMessage = theChat.messages.filter((m) => m.sender == userId);
      lastMessage.reverse();
      if (undefined !== lastMessage && lastMessage.length > 0) return lastMessage[0].message.substring(0, 20) + "..";
    },
    isActive(id) {
      const res = this.activeChatUsers.find((cu) => cu.usr_id == id) == undefined;
      return res;
    },
    isChatUser(id) {
      return this.addressExclusionList.indexOf(id) > -1 ? false : true;
    },
    async loadCurrentChatMessages() {
      this.msgLoadedran++;
      
      const messagesLoaded = this.loadedMessagesByChat.find( (c) => c.id == this.currentChat.chat.chat_id );
      if(!messagesLoaded) {
        const intialOffsetMessages = this.currentChat.chat.messages.slice(-this.offSetBase).map(msg => msg);
        const loadMessages = await this.$store.dispatch("chat/getMessagesOfDialogue", intialOffsetMessages);

        const newMessagesByChat = {
          id: this.currentChat.chat.chat_id,
          offSet: this.offSetBase,
          messages: loadMessages
        }

        this.loadedMessagesByChat.push(newMessagesByChat);
        this.currentMessages = newMessagesByChat.messages;
        this.currentMessages.sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
        this.currentMessagesLoaded = true;
      } else {        
        this.currentMessages = messagesLoaded.messages;
      }
    },
    async loadNewChatMessages() {   
      this.msgLoadedran++;
      //check if new Messages      
      if(!this.currentChat.chat) return;

      try {      
      this.lockRefresh = true;      
      const currentLenLoaded = this.currentMessages.length;
      const lastLoadedMessage = currentLenLoaded ? this.currentMessages[currentLenLoaded - 1].id : 0;
      const currentLenStore = this.currentChat.chat.messages.length;
      const lastStoreMessage = this.currentChat.chat.messages[currentLenStore - 1];
      const newMessages = lastLoadedMessage != lastStoreMessage.nachricht_id;

      if(newMessages) {
        const idxLast = this.currentChat.chat.messages.indexOf(lastLoadedMessage);        
        const newMessages = this.currentChat.chat.messages.slice(idxLast +1);        
        const loadNewMessages = await this.$store.dispatch("chat/getMessagesOfDialogue", newMessages);
        const currentLoadedMessagesByChat = this.loadedMessagesByChat.find( chat => chat.id == this.currentChat.chat.chat_id );
        currentLoadedMessagesByChat.messages.unshift(...loadNewMessages);
        currentLoadedMessagesByChat.messages.sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
        this.scrollToBottom();
      }
      } catch(err) {
        console.log(err);
      } finally {
        this.lockRefresh = false;
      }
      
    },
    async loadMoreCurrentChatMessages() {
      this.loadedRan++;

      const loadedChatMessages = this.loadedMessagesByChat.find( chat => chat.id == this.currentChat.chat.chat_id );
  
      this.loadingMore = true;
      
      //bail if all are loaded
      if(this.currentChat.chat.messages.length <= this.currentMessages.length) {
        this.loadingMore = false;
        return;
      }  

      if(this.currentChat.chat.messages.length < ((loadedChatMessages.messages.length) + (loadedChatMessages.messages.offSet + this.offsetBase))) {
        const newOffSet = this.offsetBase + loadedChatMessages.offSet;        
        const newOffsetMessages = this.currentChat.chat.messages.slice(-newOffSet, (loadedChatMessages.length - 1));        
        const loadNewMessages = await this.$store.dispatch("chat/getMessagesOfDialogue", newOffsetMessages);        
        loadedChatMessages.messages.unshift(...loadNewMessages);       
        loadedChatMessages.offSet = newOffSet;
      } else {
        const newOffSet = this.offSetBase + loadedChatMessages.offSet;      
        const start = parseInt(newOffSet);
        const end = parseInt(loadedChatMessages.offSet);
        const newOffsetMessages = this.currentChat.chat.messages.slice(-start, -end);

        const loadNewMessages = await this.$store.dispatch("chat/getMessagesOfDialogue", newOffsetMessages);
        loadedChatMessages.messages.unshift(...loadNewMessages);
        loadedChatMessages.offSet = newOffSet;        
      }
      this.scrollToTop();    
      this.loadingMore = false;  
    },
    async refreshcurrentChat() { 
      const activeChat = this.activeChats.find((ac) => ac.chat_id == this.currentChat.chat.id);      
      if(!activeChat == undefined) this.currentChat.chat = activeChat;
      if(this.lockRefresh) return;
      await this.loadNewChatMessages();      
      //await this.checkSubscribers();
    },
    getRole(userId) {
      const user = this.allUsers.find((u) => u.id == userId);
      if (undefined == user) return;
      if (user.role == '0ef37112-08ae-4f6a-b727-12f6b0d8b964') {
        return this.getThemenOfUser(userId);
      }
      if (user.role == 'f0995ff3-21fd-41a8-91fa-551469b0c5a6') return "Kunde";
      return "Default";
    },
    getThemenOfUser(id) {
      let result = [];
      try {
        for (let i = 0; i < this.themen.length; i++) {
          let ansp = this.themen[i].ansprechpartner;
          for (let a = 0; a < ansp.length; a++) {
            if (ansp[a].user_id.id == id) result.push(ansp[a].themen_id.name);
          }
        }
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim laden der Ansprechpartner Themen", this.toasts.failure);
      }
      if (!result.length) return "Infrabau Admin";
      return result.join(", ");
    },
    async selectCurrentChat(chatId) {
      const chat = this.activeChats.find((ac) => ac.chat_id == chatId);
      this.currentChat.chatMe = this.user;
      this.currentChat.chat = chat;
      this.currentChat.active = true;
      //this.currentChat.newMessage = "";
      const dialogue = this.dialogues.find((d) => d.id == chatId);
      const seenBy = dialogue.seenby ? JSON.parse(dialogue.seenby) : [];
      const isAlreadySeen = seenBy.find((s) => s == this.user.id);
      await this.loadCurrentChatMessages();
      this.scrollToBottom();
      if (!isAlreadySeen) {
        seenBy.push(this.user.id);
        const updatePayload = {
          dialogue: chatId,
          seenby: seenBy,
        };
        this.$store.dispatch("chat/setSeenByMe", updatePayload);
      }
    },
    async sendMessage() {
      if (!this.currentChat.newMessage.length) {
        this.$toasted.show("Nachrichtenfeld leer", this.toasts.failure);
        return;
      }

      const msg = this.currentChat.newMessage;

      const newMessagePayload = {
        dialogueId: this.currentChat.chat.chat_id, 
        message: this.currentChat.newMessage,
        sender: this.user.id
      } 

      try {
        this.currentChat.updating = true;
        await this.$store.dispatch("chat/sendMessage", newMessagePayload);        
        this.selectCurrentChat(this.currentChat.chat.chat_id);
        const modRecipients = this.mods.map(mod => mod.user.email);
        const subRecipients = this.activeChatUsers.map(u => u.user.email);
        const payload = {
          mode: "infrabau",
          customer: this.user,
          message: msg,
          recipients: [...modRecipients, ...subRecipients]
        }
        this.$store.dispatch("chat/sendChatMail", payload);
      } catch(err) {
        console.log(err);
        this.$toasted.show("Fehler beim Senden der Nachricht", this.toasts.failure);
      } finally {
        this.currentChat.updating = false;
        this.currentChat.newMessage = "";
      }
      this.refreshcurrentChat();
      this.scrollToBottom();
    },
    scrollToBottom() {
      const chatContainer = this.$refs.current_chat_container;
      if (undefined !== chatContainer) {
        this.$nextTick(() => {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        });
      }
    },
    scrollToTop() {
      const chatContainer = this.$refs.current_chat_container;
      if (undefined !== chatContainer) {
        this.$nextTick(() => {
          chatContainer.scrollTop = 5;
        });
      }    
    },
  },
  async mounted() {},
  async created() {
    if (!this.themen) await this.$store.dispatch("app/apiGetThemen");
    if(!this.admins) await this.$store.dispatch("chat/getAdminSubscribers");
    if (!this.currentChat.chat.length && !this.chatReady) {
      try {
        await this.$store.dispatch("chat/initChat");
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim initialisieren des Chat Systems.", this.toasts.failure);
      }
    }

    this.selectCurrentChat(this.dialogues[0].id);       
    this.ready = true;
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.focus();
      },
    },
  },
  scroll: {
    inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
  },
  computed: {
    ...mapGetters({
      animations: "app/animations",
      user: "auth/user",
      userImg: "auth/userImg",
      toasts: "app/toasts",
      chatActive: "chat/chatActive",
      chatReady: "chat/chatReady",
      activeChats: "chat/activeChats",
      activeChatUsers: "chat/activeChatUsers",
      userAddressBook: "chat/userAddressBook",
      addressBookReady: "chat/addressBookReady",
      dialogues: "chat/dialogues",
      isAdmin: "auth/isAdmin",
      kunden: "app/kunden",
      unseen: "chat/unseenMessages",
      themen: "app/themen",
      mods: "chat/mods",  
      defaultAvatarUrl: "chat/defaultAvatarUrl",
      avatars: "chat/avatars",
      customerAvatarsLoaded: "chat/customerAvatarsLoaded"
    }),
  },
};
</script>



<style scoped>
.about {
  font-weight:normal;
  font-size:0.8em;
  margin-right:20px;
}
</style>

<style>
.message {
white-space:pre-line;
}
</style>

